import {FormField, useFormContext, type FormFieldProps} from 'platform/components';

import {type FieldValues} from 'react-hook-form';

/**
 * Text field for catalogue prices, power and counts. Its schema accepts a dot or a comma and stores a
 * dot; validating on blur flags a bad number when the author leaves the field instead of on Save.
 */
export function NumberField<TFieldValues extends FieldValues>(
  props: Omit<FormFieldProps<TFieldValues, 'text'>, 'type' | 'onBlur'>
) {
  const {trigger} = useFormContext<TFieldValues>();
  return <FormField {...props} type="text" onBlur={() => void trigger(props.name)} />;
}
